// 所有方法命名集合
let host
// let BASE_API
if (process.env.NODE_ENV === 'production') {
  if (process.env.CUSTOM_ENV === 'dev') {
    host = 'https://d-hsy.lszzg.com/zzgagent-pay-customer/' // 测试环境
    // BASE_API = 'https://d-baseweb.lszzg.com/leposweb/'
  } else if (process.env.CUSTOM_ENV === 'test') {
    host = 'https://t4-zzgagent-customer.lszzg.com/zzgagent-pay-customer/' // 测试环境
    // BASE_API = 'https://t-baseweb.lszzg.com/leposweb/'
  } else if (process.env.CUSTOM_ENV === 'pre') {
    host = 'https://p-hsy.lszzg.com/zzgagent-pay-customer/' // 预发布环境
    // BASE_API = 'https://p-baseweb.lszzg.com/leposweb/'
  } else if (process.env.CUSTOM_ENV === 'prd') {
    host = 'https://zzgagent-customer.lszzg.com/zzgagent-pay-customer/' // 正式环境
    // BASE_API = 'https://baseweb.lszzg.com/leposweb/'
  }
} else {
  host = '/zzgagent-pay-customer/'
  // BASE_API = '/t-baseweb.lepass/'
}

const global = {
  validCode: host + 'home/get-valid-code',
  getMcc: host + 'application-common/get-mcc',
  mccTypeList: host + 'user-common/get-all-grandpa-mcc-info',
  mccGroupList: host + 'user-common/get-mcc-info',
  getBankList: host + 'application-common/get-bank-institution',
  validBankCard: host + 'application-common/valid-bank-card-bin',
  findBranch: host + 'application-common/find-branch-by-unionpayCode',
  getProvinceAlipay: host + 'user-common/get-all-province',
  getCityAlipay: host + 'user-common/get-city',
  getAreaAlipay: host + 'user-common/get-area',
  getAgentRealAccount: host + 'agent/get-agent-real-account',
  getMerchantRealAccount: host + 'merchant/get-merchant-real-account',
  singleTransPic: host + 'user-common/single-trans-pic',
  uploadPic: host + 'merchant-stock/upload-pic',
  agentSurvey: host + 'pre-access/intention-survery',
  getInfoByAuthCode: host + 'pre-access/get-info-by-authCode',
  uploadExtendFile: host + 'merchant-stock/upload-multipart',
  ocrCheck: host + 'application-common/ocr-check',
  modifyMerchantMobile: host + 'agent-config/modify-merchant-mobile',
  getModifyMobileCode: host + 'agent-config/get-modify-mobile-code',
  preModifyMobile: host + 'agent-config/pre-modify-merchant-mobile',
  getAreaCode: host + 'application-common/get-area-code',
  getBranch: host + 'application-common/find-branch-by-areaCode',
  getUploadToken: host + 'merchant-stock/oss-token',
  changeMerchantPs: host + 'merchant/modify-merchant-password',
  changePs: host + 'agent/modify-password',
  getAreaByCode: host + 'user-common/area',
  getMccByCode: host + 'user-common/mcc',
  getBranchByCode: host + 'user-common/bankbranch2'
}

const home = {
  riskOperFlows: host + 'risk-manage/risk-oper-flows',
  updateReadState: host + 'risk-manage/update-read-state',
  activityNotify: host + 'risk-manage/activity-notice'
}

const user = {
  agentLogin: host + 'home/agent-login',
  merchantLogin: host + 'home/merchant-login',
  logout: host + 'home/agent-logout',
  userInfo: '/user/userInfo',
  csrfToken: host + 'home/csrfToken',
  authCode: host + 'home/authCode',
  forgetPassword: host + 'home/forgetPassword',
  agentRegister: host + 'pre-access/agent-apply-register',
  synAgentId: host + 'agent-apply/synAgentId',
  getBdInfo: host + 'agent-apply/getInfo'
}

// 商户模块
const merchant = {
  merchantSale: host + 'agent/list-merchant',
  openScanOrder: host + 'agent/open-catering-state',
  openT0Settle: host + 'agent/merchant/t0-settlement',
  merchantInfo: host + 'merchant/get-detail-info',
  modifyMerchantTradeStatus: host + 'agent/modify-merchant-trade-status',
  countCardExpireMerchant: host + 'agent/count-card-expire-merchant',
  checkMerchantId: host + 'merchant-stock/check-merchantId',
  checkUsername: host + 'merchant-stock/check-username',
  directBranchRegister: host + 'merchant-stock/direct-branch-register',
  getMerchantInfo: host + 'merchant-management/get-merchant-info',
  getAvailableChannel: host + 'agent/get-available-channel',
  queryAllSale: host + 'agent/list-simple-agent-operators',
  subAgentInfo: host + 'agent/list-simple-sub-agents-info',
  exportMerchantList: host + 'agent/export-list-merchant',
  exportReportMerchantList: host + 'agent/export-list-report-merchant',
  exportExpiredMerchant: host + 'agent/export-expired-merchant-with-csv',
  intellectBatchRegister: host + 'merchant-management/intellect-batch-register',
  intellectRegister: host + 'merchant-management/intellect-register',
  updateIntellectMerchant: host + 'merchant-management/update-intellect-merchant',
  setCommission: host + 'merchant-commission/set-commission-new',
  checkMerchantStatus: host + 'merchant-management/check-merchant-status',
  getBlueSeaMerchantList: host + 'blue-sea/list-merchant',
  blueSeaArea: host + 'blue-sea/area',
  getBlueSeaInfo: host + 'blue-sea/get-info',
  updateBlueSeaInfo: host + 'blue-sea/update-detail-info',
  setBlueSeaRemark: host + 'blue-sea/remark',
  getOasisMerchantList: host + 'oasis/list-merchant',
  oasisArea: host + 'oasis/area',
  getOasisInfo: host + 'oasis/get-info',
  updateOasisInfo: host + 'oasis/update-detail-info',
  setOasisRemark: host + 'oasis/remark',
  getWxConfigInfo: host + 'agent/get-wx-config-info',
  setWxConfigInfo: host + 'agent/set-wx-config-info',
  reportWechatMerchantList: host + 'agent/list-report-wechat-merchant',
  unionActivityMerchantList: host + 'unionpay-activity/list-union-merchant-info',
  unionActivityMerchantInit: host + 'unionpay-activity/unionpay-activity-mch-init',
  exportUnionMerchant: host + 'unionpay-activity/export-union-merchant-info',
  updateDetailInfo: host + 'blue-sea/update-detail-info',
  getAgentChannel: host + 'oasis/get-agent-channel',
  checkSettleStatus: host + 'merchant-management/check-merchant-update-status',
  quicklyModifyAccount: host + 'merchant-management/quickly-modify-account-info',
  lostMerchantList: host + 'merchant-lost/list-merchant-lost',
  lostSumStatistic: host + 'merchant-lost/get-sum-merchant-trans',
  exportLostMerchant: host + 'merchant-lost/export-list-merchant-lost',
  lostStatistic: host + 'merchant-lost/statistics-merchant-lost',
  updateRefundState: host + 'agent/update-refund-state',
  agentRegisterNew: host + '/pre-access/agent-apply-register',
  updateRegister: host + 'pre-access/update-register-agent-info',
  checkAuthBusiness: host + '/application-common/auth-business',
  checkAuthIdCard: host + 'application-common/auth-idcard',
  updateContactInfo: host + 'agent/update-contact-info',
  checkMerchantTransStatus: host + '/merchant-management/check-merchant-trans-status',
  authList: host + 'activation-code-manager/grantList',
  authLogList: host + 'activation-code-manager/queryLogs',
  authServiceList: host + 'activation-code-manager/remainActivationCodeList',
  activationCodeList: host + 'activation-code-manager/activationCodeList',
  authPreOrder: host + 'activation-code-manager/createOrder',
  authActivation: host + 'activation-code-manager/grantAndActive',
  upgradeShopList: host + 'chain-logic/merchant-upgrade/shop-list',
  upgradeOrderInit: host + 'chain-logic/merchant-upgrade/order-init',
  upgradeOrderPayStatus: host + 'chain-logic/merchant-upgrade/order-pay-status',
  upgradeToChainShop: host + 'chain-logic/shop/upgradeToChainShop'
}

// 合作方模块
const partner = {
  getSalesmanGroup: host + 'staffing/getSalesmanGroup.do',
  subAgentDetail: host + 'agent/detail-agent-info',
  subAgentList: host + 'agent/list-sub-agents-info',
  exportMerchantStatement: host + 'new-agent-order/export-merchant-statement',
  getSalesmanCitys: host + 'staffing/getSalesmanCity.do',
  getSalesmanProcity: host + 'staffing/getMsProvinceAndCity.do',
  getAgFee: host + 'agent/get-agent-fee',
  addSubAgent: host + 'agent/add-or-update-sub-agent',
  getTemplateList: host + 'saas-rate/get-template-list',
  getTemplate: host + 'saas-rate/get-template-by-id',
  modifyAgentApplicationStatus: host + 'agent/modify-agent-application-status',
  checkSubAg: host + 'agent/validate-account',
  querySale: host + 'agent/list-agent-operators',
  agentDetail: host + 'agent/get-agent-info',
  updateSalesInfo: host + 'agent/update-sub-agent-info',
  resetSubAg: host + 'agent/reset-operator-password',
  freezeSaler: host + 'agent/block-operator',
  unfreezeSaler: host + 'agent/unblock-operator',
  deleteSaler: host + 'agent/delete-operator',
  addSales: host + 'agent/add-operator',
  customerList: host + 'customer/list-customer',
  customerInfo: host + 'customer/get-customer-info',
  attachAgent: host + 'customer/attach-agent',
  exportCustomer: host + 'customer/export-customer',
  // 智掌柜代理商需求二期
  listZoneChannel: host + 'agent/list-zone-channel',
  addZoneOrChannel: host + 'agent/add-zone-or-channel',
  listZone: host + 'agent/list-zone',
  listChannel: host + 'agent/list-channel',
  blockZoneChannel: host + 'agent/block-zone-channel',
  unblockZoneChannel: host + 'agent/unblock-zone-channel',
  deleteZoneChannel: host + 'agent/delete-zone-channel',
  t0Settlement: host + 'agent/t0-settlement'
}

// 交易查询模块，部分结算也有使用到
const transaction = {
  // 代理商系统 交易流水查询
  listAgentMerchant: host + 'new-agent-order/list-agent-merchant',
  listDealInfo: host + 'new-agent-order/list-deal-info',
  exportDealInfo: host + 'new-agent-order/export-deal-info',
  // 代理商系统 商户交易统计
  directSubAgentInfo: host + 'agent/list-direct-sub-agents-info',
  mtList: host + 'agent-profit/merchant-transaction-list',
  exportMtList: host + 'agent-profit/export-merchant-transaction-list',
  // 商户系统 交易流水查询
  getAllSubMerchantNames: host + 'merchant/get-all-subMerchantNames',
  listMerchantTrans: host + 'new-merchant-tran/list',
  exportMerchantTrans: host + 'new-merchant-tran/export',
  // 商户系统 总分店交易统计报表
  getTransStatistic: host + 'merchant-statistics/get-trans-statistic',
  exportTransStatistic: host + 'merchant-statistics/export-trans-statistic',
  listTradeDetail: host + 'customer/list-trade-detail',
  exportTradeDetail: host + 'customer/export-trade-detail',
  // 交易 套餐订单列表
  listPackageOrderInfo: host + 'package-order/list-package-order-info',
  // 交易流水查询
  queryTradeFlowData: host + 'package-order/query-trade-flow-data',
  // 智掌柜交易流水导出
  exportTradeFlowData: host + 'package-order/export-trade-flow-data'
}

// 结算模块
const settleAccounts = {
  // 商户系统 订单计费明细查询
  getAllSubMerchantNames: host + 'merchant/get-all-subMerchantNames',
  queryOrderBillingDetailsList: host + 'new-merchant-settle/list',
  exportOrderBillingDetails: host + 'new-merchant-settle/export',
  // 商户系统 交易订单差错处理
  listMerchantErrorTicket: host + 'new-merchant-settle/list-merchant-ticket',
  exportMerchantErrorTicket: host + 'new-agent-order/export-merchant-ticket',
  exportMerchantPaybill: host + 'new-agent-order/export-merchant-paybill',
  lookUpDetailInfo: host + 'new-agent-order/paybill-money-detail',
  listPaybill: host + 'new-agent-order/list-paybill',
  countAgentProfit: host + 'new-agent-order/count-agent-profit',
  exportCountAgentProfit: host + 'new-agent-order/export-count-agent-profit',
  queryAgentWithdrawOrder: host + 'agent-profit/query-agent-withdraw-order',
  listProfitDetail: host + 'new-agent-order/list-profit-detail',
  exportProfitDetail: host + 'new-agent-order/export-profit-detail',
  singleTranferPic: host + 'merchant-stock/single-transfer-pic-url',
  profitStatistics: host + 'agent-profit/profit-statistics',
  profitPickUp: host + 'agent-profit/pick-up',
  blueSeaPickUp: host + 'blue-sea/pick-up',
  oasisPickUp: host + 'oasis/pick-up',
  uploadInvoiceImage: host + 'agent-profit/upload-invoice-image',
  queryAgentInvoiceList: host + 'agent-profit/agent-invoice-list',
  inputAgentInvoice: host + 'agent-profit/input-agent-invoice',
  updateInvoice: host + 'agent-profit/update-agent-invoice-tmp',
  batchInputInvoice: host + 'agent-profit/batch-input-agent-invoice',
  deleteInvoice: host + 'agent-profit/delete-agent-invoice-tmp',
  invoiceList: host + 'invoice/list-invoice',
  applyInvoice: host + 'invoice/apply-invoice',
  applyInvoiceRecordList: host + 'invoice/list-invoice-apply-record',
  cancelApplyInvoice: host + 'invoice/cancel-apply-invoice',
  invoiceExport: host + 'invoice/export-invoice-apply-record',
  listPayOrder: host + 'pay-order/list-pay-order',
  exportPayOrder: host + 'pay-order/export-pay-order',
  listAccount: host + 'merchant-account/list-account',
  exportMerchantAccount: host + 'merchant-account/export-merchant-account',
  listAccountFlow: host + 'merchant-account/list-account-flow',
  exportAccountFlow: host + 'merchant-account/export-account-flow',
  accurateQuery: host + 'invoice/detail-query-invoice',
  dimQuery: host + 'invoice/fuzzy-query-invoice',
  listMerchantStatement: host + 'new-agent-order/list-merchant-statement',
  commissionPickUp: host + 'agent-profit/commission-pick-up',
  getLastApplyRecord: host + 'invoice/get-last-apply-record',
  listCustomerInvoice: host + '/customer/list-customer-invoice',
  exportCustomerInvoice: host + '/customer/export-customer-invoice',
  listCustomerProfitDetail: host + '/customer/list-profit-detail',
  exportCustomerProfitDetail: host + '/customer/export-profit-detail',
  listCustomerProfitStatistics: host + '/customer/list-customer-profit-statistics',
  exportCustomerProfitStatistics: host + '/customer/export-customer-profit-statistics',
  listAutoInvoice: host + 'autoConfigInvoice/list-auto-invoice',
  applyAutoInvoice: host + 'autoConfigInvoice/apply-auto-invoice',
  updateAutoInvoice: host + 'autoConfigInvoice/update-auto-invoice',
  updateAutoInvoiceState: host + 'autoConfigInvoice/update-auto-invoice-state',
  listAutoInvoiceMulti: host + '/autoConfigInvoice/list-auto-invoice-multi',
  rebateDetailList: host + 'invoice/rebateDetailList',
  // 收款账号管理模块
  getPayAccountList: host + 'zzg-account/getPayAccountList',
  getPayAccountShopList: host + 'zzg-account/getPayAccountShopList',
  getPayAccountUpdateLog: host + 'zzg-account/getPayAccountUpdateLog'
}

// 机具模块
const machine = {
  cancelDistributeQrcode: host + 'agent-qrcode/cancel-distribute-qrcode',
  getQrcodePage: host + 'agent-qrcode/get-qrcode-page',
  listDistributeQrcode: host + 'agent-qrcode/list-distribute-qrcode',
  distributeByAgent: host + 'agent-qrcode/distribute-by-agent',
  changeQrcodeState: host + 'agent-qrcode/change-qrcode-state',
  getQrcodeType: host + 'agent-qrcode/get-qrcode-type',
  getBindlistQrcode: host + 'merchant-qrcode/list-bind-qrcode',
  setQrcodeAudio: host + 'agent-qrcode/set-qrcode-audio',
  listMerchantQrcode: host + 'agent-qrcode/list-merchant-qrcode',
  unionRoyaltyList: host + 'unionRoyalty/list',
  unionRoyaltyOnOff: host + 'unionRoyalty/on-off',
  listMachinesDistribute: host + 'agent-machines/list-machines-distribute',
  machinePosType: host + 'agent-machines/machine-pos-type-list',
  checkMachineDistribute: host + 'agent-machines/check-machine-distribute',
  machineDistribute: host + 'agent-machines/machine-distribute',
  machineCancelDistribute: host + 'agent-machines/machine-cancel-distribute',
  machineBind: host + 'agent-machines/machine-bind',
  listLogByPinpadid: host + 'agent-machines/list-log-by-pinpadid',
  getMachineBindInfo: host + 'agent-machines/get-machine-bind-info',
  listMerchantMachines: host + 'agent-machines/list-merchant-machines',
  reworkSndetail: host + 'agent-rework/get-sn-detail',
  applyBackSn: host + 'agent-rework/update-rework-sn',
  reworkSnMsg: host + 'agent-rework/list-rework-msg',
  checkUnionQrcode: host + 'agent-qrcode/check-union-qrcode',
  listQrcode: host + 'merchant-qrcode/list-merchant-qrcode',
  applyQrcode: host + 'agent-qrcode/apply-qrcode',
  checkApplyButton: host + 'agent-qrcode/check-apply-button',
  getMerchantDetail: host + 'merchant-qrcode/get-merchant-detail',
  MerchantMachines: host + 'agent-machines/merchant-machines',
  addreworkMachine: host + 'agent-rework/addrework-sn',
  batchAddRework: host + 'agent-rework/batch-importSnRepair',
  listRuyiMachine: host + 'ruyi/list',
  queryShopId: host + 'ruyi/queryShopId',
  queryShopInfo: host + 'ruyi/queryShopInfo',
  ruyiMachineBind: host + 'ruyi/bind',
  ruyiMachineUnbind: host + 'ruyi/unBind',
  addRuyiShop: host + 'shop/create',
  listRuyiShop: host + 'shop/list',
  getReportInfo: host + 'shop/get-report-by-merchant-id',
  updateShopStatus: host + 'shop/update',
  batchUnbind: host + 'agent-qrcode/qrcode-unbind-batch',
  getUnionList: host + 'unionpay-receipt-order/list-info'
}

// 活动模块
const activity = {
  listSubsidy: host + 'agent-subsidy/list-subsidy',
  addOrUpdateSubsidy: host + 'agent-subsidy/add-or-update-subsidy',
  getSgentSubsidyDetail: host + 'agent-subsidy/get-agent-subsidy-detail',
  subsidyMoneyChange: host + 'agent-subsidy/list-agent-subsidy-money-change',
  subsidyMoneyDeductDetail: host + 'agent-subsidy/list-agent-subsidy-money-deduct-detail',
  subsidyInfo: host + 'agent-subsidy/list-subsidy-info',
  subsidyInfoDetail: host + 'agent-subsidy/list-subsidy-info-detail',
  confirmDestroySubsidy: host + 'agent-subsidy/confirm-destroy-subsidy-file',
  exportSubsidyFileDetail: host + 'agent-subsidy/export-agent-subsidy-file-detail',
  agentListWxcoupon: host + 'agent-coupon/list-coupon',
  unionActivityList: host + 'unionpay-activity/list-union-activity-info',
  unionActivityUpdateInfo: host + 'unionpay-activity/update-unionpay-activities-info',
  unionActivitySignUp: host + 'unionpay-activity/unionpay-activity-record-init',
  exportUnionActivity: host + 'unionpay-activity/export-union-activity-info',
  unionActivityBatchUpdate: host + 'unionpay-activity/batchUpdateUnionMerchantByExcel',
  merchantListWxcoupon: host + 'merchant-coupon/list-coupon',
  getRewardList: host + 'appPolicy/agentList',
  exportReward: host + 'appPolicy/agentListExport',
  getStageList: host + 'appPolicy/stageList',
  queryInvoiceDetail: host + 'appPolicy/queryInvoice',
  applyRewardDetail: host + 'appPolicy/queryApplyAward',
  writeInvoiceInfo: host + 'agent-profit/input-agent-invoice',
  uploadInvoiceImage: host + 'agent-profit/upload-invoice-image',
  getWechatActivityList: host + 'wx-rate-activity/list-report-activity-info',
  getWechatMerchantList: host + 'wx-rate-activity/list-merchant-report-info',
  getWechatAuditList: host + 'wx-rate-activity/query-merchant-report-record',
  exportWechatActivity: host + 'wx-rate-activity/export-merchant-report-file',
  updateAuditState: host + 'wx-rate-activity/update-merchant-report-status',
  reSignActivity: host + 'wx-rate-activity/merchant-batch-report-again',
  signActivity: host + 'wx-rate-activity/single-merchant-report-activity',
  batchSignActivity: host + 'wx-rate-activity/merchant-report-activity',
  batchSignFrontActivity: host + 'wx-rate-activity/merchant-report-activity-front',
  getSignInfo: host + 'wx-rate-activity/search-merchant-by-id',
  submitSignInfo: host + 'wx-rate-activity/update-merchant-report-info',
  applyReward: host + 'appPolicy/applyAward'
}

// 风控模块
const risk = {
  riskList: host + 'risk-manage/list-risk-tickets',
  riskTicketsDetail: host + 'risk-manage/risk-tickets-detail',
  exportRiskTickets: host + 'risk-manage/export-risk-tickets',
  riskTicketsFormDetails: host + 'risk-manage/get-risk-tickets',
  checkNoPassItem: host + 'risk-manage/check-nopass-item',
  commitRiskTicket: host + 'risk-manage/commit-risk-tickets',
  offlineCheck: host + 'risk-manage/offline-check',
  manualAppealCommit: host + 'risk-manage/manual-appeal-commit'
}

// 渠道模块
const channel = {
  exportAlipayMechant: host + 'agent-report/export-alipay-merchant',
  queryAlipayMechant: host + 'agent-report/list-alipay-merchant',
  queryCupsMechant: host + 'agent-report/list-cups-merchant',
  exportCupsMechant: host + 'agent-report/export-cups-merchant',
  exportQRAMechant: host + 'agent-report/export-qra-merchant',
  queryQRAMechant: host + 'agent-report/list-qra-merchant',
  exportQRCMechant: host + 'agent-report/export-qrc-merchant',
  queryQRCMechant: host + 'agent-report/list-qrc-merchant',
  updateWxAuthorizestate: host + 'agent-report/update-wechat-authorizestate',
  queryWxMechant: host + 'agent-report/list-wx-merchant',
  exportWxMechant: host + 'agent-report/export-wx-merchant',
  scheduleCheckList: host + 'wechat-certificate/list-check-schedule',
  subMerchantCheckList: host + 'wechat-certificate/subMerchant-check-list',
  cancelApplyWx: host + 'wechat-certificate/cancel-apply',
  certificateCommit: host + 'wechat-certificate/commitByExcel',
  agentChannelList: host + 'wechat-certificate/list-agent-channel',
  uploadChannelQrCode: host + 'wechat-certificate/upload-channel-qrcode',
  refreshStatus: host + 'wechat-certificate/refresh-check-schedule'
}

// 设置
const setting = {
  getTemplateManagementList: host + 'saas-rate/template-list',
  getMcFee: host + 'merchant-stock/get-rate',
  getMACost: host + 'merchant-stock/merchant-agent-cost',
  templateChangeStatus: host + 'saas-rate/template-change-status',
  templateDelete: host + 'saas-rate/template-delete',
  templateAdd: host + 'saas-rate/template-add',
  templateUpdate: host + 'saas-rate/template-update',
  downloadRecord: host + 'user-common/list-download-record',
  downloadFile: host + 'user-common/download-file',
  removeDownload: host + 'user-common/remove-download-record'
}

// 商户系统 收银员管理
const cashier = {
  cashierDetail: host + 'merchant/get-cashier-detail',
  resetSubCashier: host + 'merchant/reset-operator-password',
  freezeCashier: host + 'merchant/block-operator',
  unfreezeCashier: host + 'merchant/unblock-operator',
  deleteCashier: host + 'merchant/delete-operator',
  listCashierAc: host + 'merchant/list-merchantcashier-account',
  cashierName: host + 'merchant/get-allcashiername',
  validateCashierAc: host + 'merchant/validate-account',
  addCashierAc: host + 'merchant/add-merchant-cashier',
  updateCashierAc: host + 'merchant/update-merchant-cashier'
}

// 商户系统 分账
const subAccount = {
  accredit: host + 'merchant/subAccount/accredit',
  elecContractAccredit: host + 'merchant/subAccount/elecContractAccredit',
  accreditQuery: host + 'merchant/subAccount/accreditQuery',
  pageBind: host + 'merchant/subAccount/pageBind',
  subAccountBind: host + 'merchant/subAccount/bind',
  subAccountUnBind: host + 'merchant/subAccount/unBind',
  pageSubAccount: host + 'merchant/subAccount/pageSubAccount',
  createSubAccount: host + 'merchant/subAccount/createSubAccount',
  cancelSubAccount: host + 'merchant/subAccount/cancelSubAccount',
  pageIncome: host + 'merchant/subAccount/pageIncome',
  createBatchSubAccount: host + 'merchant/subAccount/createBatchSubAccount',
  exportSubAccount: host + 'merchant/subAccount/exportSubAccount',
  exportIncomes: host + 'merchant/subAccount/exportIncomes'
}
// 员工管理模块
const userAccount = {
  exportUserAccountDetails: host + 'zzg-user/exportUserAccountDetails',
  getUserAccountList: host + 'zzg-user/getUserAccountList',
  editUserAccount: host + 'zzg-user/editUserAccount',
  getAllRoleInfo: host + 'zzg-user/getAllRoleInfo',
  getAllRelateShopInfo: host + 'zzg-user/getAllRelateShopInfo',
  checkNewPhone: host + 'zzg-user/checkNewPhone',
  delUserAccount: host + 'zzg-user/delUserAccount',
  getUserAccountDetail: host + 'zzg-user/getUserAccountDetail',
  // 角色权限管理模块
  addRole: host + 'zzg-role/addRole',
  queryRole: host + 'zzg-role/queryRole',
  queryUserByRole: host + '/zzg-role/queryUserByRole',
  modifRole: host + 'zzg-role/modifRole',
  delRole: host + 'zzg-role/delRole',
  queryMenu: host + 'zzg-role-menu/queryMenu',
  saveMenu: host + 'zzg-role-menu/saveMenu'

}
// 连锁店店铺信息
const chainStore = {
  getShopList: host + 'zzg-shop/getShopList',
  editShop: host + 'zzg-shop/editShop',
  getShopInfo: host + 'zzg-shop/getShopInfo',
  updateMerchantId: host + 'zzg-shop/updateMerchantId',
  getPartnerInfo: host + 'zzg-shop/getPartnerInfo',
  getZoneInfo: host + 'zzg-shop/getZoneInfo',
  unboundMerchantId: host + 'zzg-shop/unboundMerchantId',
  getSmsCode: host + 'zzg-shop/getSmsCode',
  getPicCode: host + 'zzg-shop/getPicCode',
  updatePhone: host + 'zzg-shop/updatePhone',
  chainGetShopList: host + 'chain-logic/shop/list',
  activeCodeList: host + 'chain-logic/agent/active-code/list',
  chainShopCreate: host + 'chain-logic/shop/create',
  chainShopUpdate: host + 'chain-logic/shop/update',
  chainShopRelativeMerchant: host + 'chain-logic/shop/relative-merchant',
  chainSmsCode: host + 'chain-logic/shop/sms-code',
  chainGroupBrandList: host + 'chain-logic/group-brand/list',
  getChainShopInfo: host + 'chain-logic/shop/info'
}
// 加盟商管理模块
const partnerManagement = {
  getPartnerList: host + 'partner-management/get-partner-list',
  getPartnerDetail: host + 'partner-management/get-partner-detail',
  addPartner: host + 'partner-management/add-partner',
  modifyPartner: host + 'partner-management/modify-partner',
  getCreateSmsCode: host + 'partner-management/create-partner/get-sms-code',
  getChangeSmsCode: host + 'partner-management/change-phone/get-sms-code',
  submitPhone: host + 'partner-management/change-phone/submit',
  getSelectBrandList: host + 'partner-management/get-select-brand-list'
}
// 品牌管理
const barndManagement = {
  getBrandList: host + 'brand-management/get-brand-list',
  getBrandDetail: host + 'brand-management/get-brand-detail',
  addBrand: host + 'brand-management/add-brand',
  modifyBrand: host + 'brand-management/modify-brand',
  deleteBrand: host + 'brand-management/delete-brand'
}

// 区域管理
const zoneManagement = {
  getZoneLayerList: host + 'zone-management/get-zone-layer-list',
  addZone: host + 'zone-management/add-zone',
  deleteZone: host + 'zone-management/delete-zone',
  modifyZone: host + 'zone-management/modify-zone',
  getZoneDetail: host + 'zone-management/get-zone-detail'
}

// 图片上传接口
const commonApi = {
  zzgCommonUploadPic: host + 'zzg-common/upload-pic'
}
export default {
  ...global,
  ...home,
  ...user,
  ...merchant,
  ...partner,
  ...transaction,
  ...settleAccounts,
  ...machine,
  ...activity,
  ...risk,
  ...channel,
  ...setting,
  ...cashier,
  ...subAccount,
  ...userAccount,
  ...chainStore,
  ...partnerManagement,
  ...barndManagement,
  ...zoneManagement,
  ...commonApi,
  host: host
}
